import dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

const configure = () => {
  dayjs.extend(isBetween);
  dayjs.extend(isSameOrAfter);
};

export {configure};